"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var FormLabel_1 = require("../FormLabel");
var hocs_1 = require("../hocs");
var StyledTextInput_1 = require("../TextInput/StyledTextInput");
var withFormFields_hoc_1 = require("../withFormFields/withFormFields.hoc");
var StyledDropDownList_1 = require("./StyledDropDownList");
var DropDownList = /** @class */ (function (_super) {
    tslib_1.__extends(DropDownList, _super);
    function DropDownList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputRef = React.createRef();
        return _this;
    }
    DropDownList.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, forwardRef = _a.forwardRef, placeholder = _a.placeholder, label = _a.label, theme = _a.theme, error = _a.error, errorIcon = _a.errorIcon, errorMessage = _a.errorMessage, options = _a.options, value = _a.value, onChange = _a.onChange, autoComplete = _a.autoComplete, textSize = _a.textSize, lineHeight = _a.lineHeight, textColor = _a.textColor, rest = tslib_1.__rest(_a, ["id", "forwardRef", "placeholder", "label", "theme", "error", "errorIcon", "errorMessage", "options", "value", "onChange", "autoComplete", "textSize", "lineHeight", "textColor"]);
        if (placeholder && options && !options.find(function (option) { return option.value === ''; })) {
            options.unshift({ label: placeholder, value: '' });
        }
        var optionValue = value && options ? options.findIndex(function (option) { return isEqual_1.default(option.value, value); }) : value;
        return (React.createElement(StyledDropDownList_1.StyledDropDownContainer, null,
            label && (React.createElement(FormLabel_1.FormLabel, { htmlFor: id, size: textSize, lineHeight: lineHeight, color: textColor },
                label,
                " ",
                error && errorIcon)),
            React.createElement(StyledDropDownList_1.StyledDropdownWrapper, null,
                React.createElement(StyledDropDownList_1.StyledDropDownList, tslib_1.__assign({ ref: forwardRef || this.inputRef, autoComplete: autoComplete || '-', theme: theme, error: error, onChange: function (event) { return _this.onValueChange(event); }, value: optionValue, id: id, "aria-invalid": !!error }, rest), options &&
                    options.map(function (option, index) { return (React.createElement(StyledDropDownList_1.StyledOption, { theme: theme, key: 'option-' + index, id: id && id + "-" + index, value: index }, option.label)); }))),
            error && (React.createElement(StyledTextInput_1.StyledError, { theme: theme, id: id && "error-" + id, textSize: textSize }, errorMessage))));
    };
    DropDownList.prototype.onValueChange = function (event) {
        var _a = this.props, options = _a.options, onChange = _a.onChange, name = _a.name;
        if (onChange && options) {
            var target = event.target || event.currentTarget;
            if (target && target.value) {
                var selectedIndex = parseInt(target.value, 10);
                onChange({ target: { name: name, value: options[selectedIndex].value } });
            }
            else {
                onChange(event);
            }
        }
    };
    DropDownList.defaultProps = {
        placeholder: 'Please select an option'
    };
    return DropDownList;
}(React.PureComponent));
var DropDownListWrapper = recompose_1.compose(hocs_1.withFocus, styled_components_1.withTheme, hocs_1.withForwardRef)(DropDownList);
exports.DropDownList = DropDownListWrapper;
exports.FormDropDownList = withFormFields_hoc_1.withFormFields(DropDownList);
//# sourceMappingURL=DropDownList.js.map